/**
 * First-party, cookie-free event logging used by the internal traffic
 * dashboard (`/admin/traffic`). GA4 stays the marketing analytics source of
 * truth; this table exists so the owner can see tool-page reach and signups
 * without leaving the site.
 */
import { supabase } from "@/integrations/supabase/client";

export type SiteEventType = "page_view" | "newsletter_signup" | "shop_click";

const SESSION_KEY = "kcc_session_id";

function getSessionId(): string | null {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = crypto.randomUUID();
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}

/** Fire-and-forget: never block or break the UI if logging fails. */
export function logSiteEvent(
  eventType: SiteEventType,
  path?: string,
  label?: string,
): void {
  try {
    const payload = {
      event_type: eventType,
      path: (path ?? window.location.pathname).slice(0, 300),
      label: label ? label.slice(0, 200) : null,
      session_id: getSessionId(),
      referrer: document.referrer ? document.referrer.slice(0, 300) : null,
    };
    void supabase
      .from("site_events")
      .insert([payload])
      .then(
        () => undefined,
        () => undefined,
      );
  } catch {
    /* analytics must never surface an error to visitors */
  }
}
